import * as React from 'react';
import { Stack, Text, Heading as HeadingText } from '@front10/base-elements';
import { useTranslation } from '@front10/utils';

interface Props {
  componentName?: string;
  showTitle?: boolean;
  showSubtitle?: boolean;
}

const title = 'This AO, Go All Out.';
const subtitle =
  'Australian Open 2022 has Premium Experiences for every kind of fan. From the best seats in the house to the best restaurants in the world, find an AO experience that is made just for you.';

export function Heading({
  componentName = 'premium-experience-grid',
  showTitle = true,
  showSubtitle = false
}: Props) {
  const translate = useTranslation();
  return (
    <Stack data-container-heading gap="md" pb="18px">
      <div data-text-wrapper>
        {showTitle && (
          <HeadingText variant="title" data-container-title>
            {translate(`cmp-${componentName}-title`, title)}
          </HeadingText>
        )}
        {showSubtitle && (
          <Text variant="subtitle" data-container-subtitle>
            {translate(`cmp-${componentName}-subtitle`, subtitle)}
          </Text>
        )}
      </div>
    </Stack>
  );
}
